/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'locales/en-circle': {
    width: 60,
    height: 60,
    viewBox: '0 0 60 60',
    data: `
      <g clip-path="url(#clip0_340_1299)">
      <mask id="mask0_340_1299" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="-1" width="60" height="62">
      <path d="M59.9985 -1H0.000976562V60.9972H59.9985V-1Z" fill="white"/>
      </mask>
      <g mask="url(#mask0_340_1299)">
      <path d="M15.8089 0.0361328H-14.1902V24.4354H15.8089V0.0361328Z" fill="#004073"/>
      <path d="M15.8089 36.5969H-14.1902V60.9962H15.8089V36.5969Z" fill="#003F73"/>
      <path d="M15.8089 24.4216H-14.1902V36.6212H15.8089V24.4216Z" fill="#FFCC00"/>
      <path d="M27.6852 0.00146484H15.6855V60.9995H27.6852V0.00146484Z" fill="#FFCC00"/>
      <path d="M81.3027 24.425H27.3044V36.6247H81.3027V24.425Z" fill="#FFCC00"/>
      <path d="M81.6731 36.6006H27.6748V60.9998H81.6731V36.6006Z" fill="#003F73"/>
      <path d="M81.6731 0.0361328H27.6748V24.4354H81.6731V0.0361328Z" fill="#003F73"/>
      <mask id="mask1_340_1299" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="60" height="61">
      <path d="M60 0H0V61H60V0Z" fill="white"/>
      </mask>
      <g mask="url(#mask1_340_1299)">
      <path d="M88.75 0H-31.2524V61.0012H88.75V0Z" fill="#000066"/>
      <path d="M-30 0V6.82014L76.5861 61.0014H90.0024V54.1815L-16.5837 0.000203337L-30 0ZM90.0024 0V6.81994L-16.5837 61.0012H-30V54.1813L76.5861 0H90.0024Z" fill="white"/>
      <path d="M20.001 0V61.0012H40.0014V0H20.001ZM-30 20.3337V40.6675H90.0024V20.3337H-30Z" fill="white"/>
      <path d="M-30 24.4005V36.6007H90.0024V24.4005H-30ZM24.0011 0V61.0012H36.0013V0H24.0011Z" fill="#CC0000"/>
      <path d="M-30 61.0012L10.0008 40.6675H18.945L-21.0558 61.0012H-30ZM-30 0L10.0008 20.3337H1.05662L-30 4.54683L-30 0ZM41.0574 20.3337L81.0582 0H90.0024L50.0016 20.3337H41.0574ZM90.0024 61.0012L50.0016 40.6675H58.9458L90.0024 56.4546V61.0012Z" fill="#CC0000"/>
      </g>
      </g>
      </g>
      <defs>
      <clipPath id="clip0_340_1299">
      <rect width="60" height="60" rx="30" fill="white"/>
      </clipPath>
      </defs>
    `
  }
})
